import { CloseOutlined } from '@mui/icons-material';
import { Alert, AlertTitle, IconButton, Stack, type AlertColor } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';

export type InlineNoticeProps = {
  id?: string;
  severity?: AlertColor;
  title?: ReactNode;
  children: ReactNode;
  /** 정적 안내는 읽기를 방해하지 않고, 새 처리 결과만 알립니다. */
  announcement?: 'off' | 'polite' | 'assertive';
  density?: 'regular' | 'compact';
  action?: ReactNode;
  onClose?: () => void;
};

/** 영역에 남는 안내입니다. 입력 오류는 Field, 짧은 처리 결과는 FeedbackSnackbar를 사용합니다. */
export function InlineNotice({ id, severity = 'info', title, children, announcement = 'off', density = 'regular', action, onClose }: InlineNoticeProps) {
  return <Alert
    id={id}
    severity={severity}
    role={announcement === 'assertive' ? 'alert' : announcement === 'polite' ? 'status' : 'note'}
    aria-live={announcement === 'off' ? undefined : announcement}
    aria-atomic={announcement === 'off' ? undefined : true}
    action={action != null && onClose ? <Stack direction="row" useFlexGap spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>{action}<IconButton size="small" color="inherit" aria-label="닫기" onClick={onClose}><CloseOutlined fontSize="small" /></IconButton></Stack> : action}
    onClose={action != null ? undefined : onClose}
    closeText="닫기"
    sx={{
      ...(density === 'compact' ? { p: `${designTokens.feedback.notice.compactInset}px` } : {}),
    }}
  >
    {title ? <AlertTitle>{title}</AlertTitle> : null}
    {children}
  </Alert>;
}
